module.exports = __webpack_public_path__ + "img/HQ-ENC-V1.e40dfb62.jpg";